import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from '@nuxtjs/composition-api';

// ! There are separate props also in SvgThemedIconProps.ts file,
// ! due to vue version, we cannot use imported types in the component itself
// ! so we have to duplicate the types to use in ts files
export interface Props {
    name: string,
    path?: string,
    theme?: 'light' | 'dark',
    size?: 'l' | 'm' | 's' | 'xl' | 'big-s' | 'big-m' | 'big-l' | 'big-xl',
    sizeOnlySide?: 'w' | 'h',
    color?: string,
    active?: boolean,
    activatable?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'SvgThemedIcon',
  props: {
    name: null,
    path: null,
    theme: null,
    size: { default: 'm' },
    sizeOnlySide: null,
    color: { default: 'neutral-icons-shade-40-90' },
    active: { type: Boolean },
    activatable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { name: string, path?: string, theme?: 'light' | 'dark', size: 'l' | 'm' | 's' | 'xl' | 'big-s' | 'big-m' | 'big-l' | 'big-xl', sizeOnlySide?: 'w' | 'h', color: string, active?: boolean, activatable?: boolean };

;



const {
    size,
    theme,
    color,
    name,
    path,
    active,
    activatable,
    sizeOnlySide,
} = toRefs(props);

const componentType = computed(() => {
    return require(`~/assets/affility/icons/${path.value ? path.value + '/' : ''}${name.value}.svg?inline`)
});


return { __sfc: true,props, size, theme, color, name, path, active, activatable, sizeOnlySide, componentType }
}

})